
    import __i18nConfig from '@next-translate-root/i18n.js'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { GetStaticPropsContext, GetStaticPropsResult } from "next";
import { getPageData, PageProps } from "@lib/frontend/pages/webPage";
import { StrapiPages } from "@lib/strapi/pages";
import ModularPage from "@components/layout/pages/ModularPage";
export default function Page(props: PageProps) {
    return <ModularPage {...props}/>;
}
const getStaticProps = async (context: GetStaticPropsContext): Promise<GetStaticPropsResult<PageProps>> => getPageData(context, StrapiPages.home);

    async function __Next_Translate__getStaticProps__1a09d3969a8__(ctx) {
      if (typeof global !== 'undefined') {
        global.i18nConfig = __i18nConfig
      }
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || (() => Promise.resolve({})),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a09d3969a8__ as getStaticProps }
  